module.exports = __webpack_public_path__ + "img/demo-home.fa06df3b.png";